
/* injects from baggage-loader */
require('./style.scss');

import React from 'react';
import PropTypes from 'prop-types';
import Config from '../../../../../config/main';
import { useDispatch } from 'react-redux';
import { OpenPopup } from '../../../../../actions/ui';
import { t } from '../../../../../helpers/translator';

const BetBuilderIcon = ({ game }) => {
    const dispatch = useDispatch();
    const iconAvailable = Config.betting.enableBetBuilder && game?.sportcast_id;

    if (!iconAvailable) return null;

    const openBetBuilder = () => {
        const popupData = {
            title: `${game.team1_name} vs ${game.team2_name}`,
            sportcastId: game.sportcast_id
        };

        dispatch(OpenPopup('betBuilder', popupData));
    }

    return <div className={`bet-builder-icon global-icon ${t('icon-bet-builder')}`} onClick={openBetBuilder} />;
};

BetBuilderIcon.propTypes = {
    game: PropTypes.object,
};

export default BetBuilderIcon;